import { ApiBase } from '../ApiBase';
class MembershipsCreatorV2ApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.createImagePost = (requestBody) => {
            return this.post('/creators/api/v2/posts/images', requestBody);
        };
        this.updateImagePost = (params, requestBody) => {
            return this.put(`/creators/api/v2/posts/images/${params.id}`, requestBody);
        };
        this.getTiers = () => {
            return this.get('/creators/api/v2/tiers/paids');
        };
        this.getTier = (params) => {
            return this.get(`/creators/api/v2/tiers/paids/${params.id}`);
        };
        this.createTier = (requestBody) => {
            return this.post('/creators/api/v2/tiers/paids', requestBody);
        };
        this.updateTier = (params, requestBody) => {
            return this.patch(`/creators/api/v2/tiers/paids/${params.id}`, requestBody);
        };
        this.getTierPerks = (query) => {
            const getQuery = () => {
                if (!query)
                    return '';
                if (query.tier.type === 'free')
                    return `tier[type]=free`;
                return `tier[id]=${query.tier.id}&tier[type]=paid`;
            };
            return this.get(`/creators/api/v2/perks/tiers?${getQuery()}`);
        };
        this.reorderTierPerks = (params, query, body) => {
            const getQuery = () => {
                if (!query)
                    return '';
                if (query.tier.type === 'free')
                    return `tier[type]=free`;
                return `tier[type]=paid&tier[id]=${query.tier.id}`;
            };
            return this.post(`/creators/api/v2/perks/tiers/reorder/${params.id}?${getQuery()}`, body);
        };
        this.getPriceRates = (query) => {
            return this.get(`/creators/api/v2/tiers/paids/price_rates`, query);
        };
        this.getSeries = (query) => {
            return this.get('/creators/api/v2/series/posts', query);
        };
        this.getSingleSeries = (params) => {
            return this.get(`/creators/api/v2/series/posts/${params.id}`);
        };
        this.createSingleSeries = (requestBody) => {
            return this.post('/creators/api/v2/series/posts', requestBody);
        };
        this.updateSingleSeries = (params, requestBody) => {
            return this.put(`/creators/api/v2/series/posts/${params.id}`, requestBody);
        };
        this.deleteSingleSeries = (params) => {
            return this.delete(`/creators/api/v2/series/posts/${params.id}`);
        };
        this.reorderSingleSeries = (params, requestBody) => {
            return this.post(`/creators/api/v2/series/posts/${params.id}/reorder`, requestBody);
        };
        this.getPostSeries = (params, query) => {
            return this.get(`/creators/api/v2/series/posts/posts/${params.id}`, query);
        };
        this.createLiveStreamPost = (requestBody) => {
            return this.post('/creators/api/v2/posts/live_streams', requestBody);
        };
        this.updateLiveStreamPost = (params, requestBody) => {
            return this.patch(`/creators/api/v2/posts/live_streams/${params.id}`, requestBody);
        };
        this.startLiveStreamPost = (params) => {
            return this.post(`/creators/api/v2/posts/live_streams/${params.id}/start`);
        };
        this.finishLiveStreamPost = (params) => {
            return this.post(`/creators/api/v2/posts/live_streams/${params.id}/finish`);
        };
        this.getResourceLiveStream = (params) => {
            return this.get(`/creators/api/v2/posts/live_streams/resource_live_streams/${params.id}`);
        };
        this.getResourceLiveStreamNotAttached = () => {
            return this.get('/creators/api/v2/posts/live_streams/resource_live_streams/show_not_attached');
        };
    }
}
export const MembershipsCreatorV2ApiClient = new MembershipsCreatorV2ApiClientModel('/');
